import React from "react";
import { useLocation } from "react-router-dom";
import AddRepairingOrder from "./AddRepairingOrder";
import { useButtonTableStyle } from "../utils/useButtonTableStyle";
import "../assets/css/theme-table-header.css";

const EditRepairingOrder = ({ masterGoldRate, masterSilverRate }) => {
  const location = useLocation();
  const repairingOrderId =
    location.state?.repairingOrderId || location.state?.id;
  const cardClass = useButtonTableStyle();

  return (
    <div className={`body-wrapper ${cardClass}`}>
      <AddRepairingOrder
        masterGoldRate={masterGoldRate}
        masterSilverRate={masterSilverRate}
        pageTitle="Edit Repair Order"
      />
    </div>
  );
};

export default EditRepairingOrder;
